export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-book-bookmark-fa84836ee7f721e911942259d9e32e69.svg";